export default __webpack_public_path__ + "static/media/a_chrobak_lesni-min.bfd4a34d.jpg";